import {h, Fragment} from "preact"
import { useSort } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks";
import { sortOptions } from "../../config"

export default function SortDropdown() {
    const { activeSort, setSort } = useSort(sortOptions);
    const [ sortOpen, setSortOpen] = useState(false);
    const dropdownRef = useRef(null);
    const toggleRef = useRef(null);

    // keydown 'esc' will close dropdown
    useEffect(() => {
        const handleKeydown = (event) => {
            if(event.key === 'Escape' || event.keyCode === 27) {
                toggleSort();
            }
        }
        if(sortOpen) {
            window.document.addEventListener('keydown', handleKeydown)
            return () => window.document.removeEventListener('keydown', handleKeydown)
        }
    }, [ sortOpen ])

    // click outside will close dropdown
    useEffect(() => {
        const handleClick = (event) => {
            if(
                !dropdownRef.current.contains(event.target) && 
                !toggleRef.current.contains(event.target)
            ) {
                toggleSort();
            };
        };

        if(sortOpen && dropdownRef?.current && toggleRef?.current) {
            window.document.addEventListener('click', handleClick);
            return () => window.document.removeEventListener('click', handleClick);
        };
    }, [sortOpen, dropdownRef, toggleRef]);

    const handleSortChange = (event) => {
        setSort(event.target.value);
        toggleSort();
    };

    const toggleSort = () => {
        setSortOpen(prevSortOpen => !prevSortOpen);
    };

    return (
        <div class="ns-dropdown-container">
            <div>
                <button
                    className="flex justify-end items-center cursor-pointer w-fit"
                    type="button"
                    aria-haspopup="true"
                    aria-controls="ns-sort-dropdown"
                    aria-labelledby="sort-label"
                    aria-expanded={sortOpen}
                    tabIndex="0"
                    onClick={toggleSort}
                    ref={toggleRef}
                >
                    <span
                        className="body-2 pr-[5px] pl-[16px] cursor-pointer lg:pl-[30px]"
                        id="sort-label"
                    >
                        Sort By:
                    </span>
                    <span className="body-2--medium hidden lg:inline">
                        {sortOptions.find(option => option.id === activeSort).value.name}
                    </span>
                    <svg className={`lg:mr-[31.6px] ${sortOpen ? "rotate-180" : ""}`} aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Arrow down">
                        <path d="M12 8L8 12L4 8" stroke="#2D2926" stroke-miterlimit="16" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>
                </button>
            </div>
            <div
                className="absolute bg-white m-w-full z-1"
                id="ns-sort-dropdown"
                aria-hidden={!sortOpen}
                ref={dropdownRef}
                tabIndex="0"
                >
                <ul className="ns-sort-menu bg-background-0 z-30 absolute mt-[20px] w-[200px] h-fit flex flex-col lg:w-[290px] lg:h-auto lg:pr-[0px] lg:right-0 lg:right-auto lg:mt-[2px] lg:top-[30px] lg:pt-[0px]">
                    {sortOptions.map((option) => (
                        <li 
                            key={option.id}
                            class="ns-sort-option pb-[20px] pl-[20px] pr-[20px] lg:pb-[16px] lg:border-b-0"
                        >
                            <label
                                className="wrap flex flex-row items-center cursor-pointer"
                            >
                                <input
                                    className="visually-hidden sr-only"
                                    type="radio"
                                    name="ns-sort"
                                    value={option.id} 
                                    checked={(activeSort === option.id)}
                                    onChange={handleSortChange}
                                />
                                <span className={`hover:underline ${activeSort === option.id ? "underline body-2--medium" : ""}`}>
                                    {option.value.name}
                                </span>
                            </label>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}
